/**
 * UTF-16 Little Endian Encoding.
 *
 *
 * @beta
 */
export const UTF_16_LE = 'utf-16le'
